const OnboardingActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  CHANGE_PHASE: 'change_phase',
  UPDATE_CHECKED_PHASES: 'update_checked_phases',
  UPDATE_SIGNUP_STEPS: 'update_signup_steps',
  UPDATE_REGISTRATION_STEPS_STATUS: 'update_registration_steps_status',
  UPDATE_MAIN_SETTINGS: 'update_main_settings',
};

const OnboardingReducer = (state, action) => {
  switch (action.type) {
    case OnboardingActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case OnboardingActionTypes.CHANGE_PHASE:
      return {
        ...state,
        currentPhase: action.payload.screen,
      };
    case OnboardingActionTypes.UPDATE_CHECKED_PHASES:
      return {
        ...state,
        checkedPhases: {
          ...state.checkedPhases,
          [`${action.payload.key}`]: action.payload.value,
        },
      };

    case OnboardingActionTypes.UPDATE_SIGNUP_STEPS:
      return {
        ...state,
        signupSteps: {
          ...state.signupSteps,
          [action.payload.stepName]: {
            ...state.signupSteps[`${action.payload.stepName}`],
            checked: action.payload.checked,
          },
        },
      };

    case OnboardingActionTypes.UPDATE_REGISTRATION_STEPS_STATUS:
      return {
        ...state,
        registrationStepsOpened: action.payload,
      };

    case OnboardingActionTypes.UPDATE_MAIN_SETTINGS:
      return { ...state, mainSettings: action.payload };

    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: OnboardingActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const updatePhase = (dispatch) => (phase) =>
  dispatch({ type: OnboardingActionTypes.CHANGE_PHASE, payload: phase });

const updateCheckedPhases = (dispatch) => (key, value) =>
  dispatch({ type: OnboardingActionTypes.UPDATE_CHECKED_PHASES, payload: { key, value } });

const updateSignupSteps = (dispatch) => (stepName, checked) =>
  dispatch({ type: OnboardingActionTypes.UPDATE_SIGNUP_STEPS, payload: { stepName, checked } });

const openRegistrationStepsPopup = (dispatch) => () =>
  dispatch({ type: OnboardingActionTypes.UPDATE_REGISTRATION_STEPS_STATUS, payload: true });

const closeRegistrationStepsPopup = (dispatch) => () =>
  dispatch({ type: OnboardingActionTypes.UPDATE_REGISTRATION_STEPS_STATUS, payload: false });

const updateMainSettings = (dispatch) => (settings) =>
  dispatch({ type: OnboardingActionTypes.UPDATE_MAIN_SETTINGS, payload: settings });

// eslint-disable-next-line import/prefer-default-export
export const onboarding = {
  OnboardingReducer,
  actions: {
    openScreen,
    updatePhase,
    updateCheckedPhases,
    updateSignupSteps,
    openRegistrationStepsPopup,
    closeRegistrationStepsPopup,
    updateMainSettings,
  },
};
